export const postData = {
  "posts": [
    {
      "title": "Ancient Civilizations",
      "date": "January 1, 2023",
      "image": "/assets/FeedItems/BBjjpbhHhMMZs6E2PDu.svg",
      "summary": "Summary: Explore the rise and fall of early human societies, including the Egyptians, Mesopotamians, Indus Valley Civilization, and the Inca Empire. Discover their remarkable achievements and lasting legacies.",
      "path": "blog/history/post/posthistory1"
    },
    {
      "title": "Renaissance Insights",
      "date": "February 1, 2023",
      "image": "/assets/FeedItems/BBkaMGe503fFKsePJPf.svg",
      "summary": "Uncover the rebirth of knowledge, art, and scientific discovery during the Renaissance period. Learn about humanism, artistic achievements, scientific advancements, exploration, and literary contributions.",
      "path": "blog/history/post/posthistory2"
    },
    {
      "title": "Introduction to Mindfulness",
      "date": "May 1, 2023",
      "image": "/assets/FeedItems/Xd9ntRxM19SBc3w0VF3z.svg",
      "summary": "Understand the practice of mindfulness and its benefits. Learn about what mindfulness is, its benefits, and how to practice it in daily life.",
      "path": "blog/mindfulness/post/postmindfulness1"
    },
    {
      "title": "Integrating NLP and Mindfulness for Enhanced Self-Awareness",
      "date": "June 1, 2023",
      "image": "/assets/FeedItems/BBjaYY56JcQNTdAHHCt.svg",
      "summary": "Explore the synergy of NLP and mindfulness to foster self-awareness and emotional resilience. Learn techniques to transform your thoughts and responses for a more balanced mind.",
      "path": "blog/mindfulness/post/Postmindfulness2"
    },
    {
      "title": "Mindful Reframing: Transforming Negative Thoughts",
      "date": "July 1, 2023",
      "image": "/assets/FeedItems/BBxS4uQxFxtpTGCq6Gm.svg",
      "summary": "Learn how to transform negative thoughts into positive opportunities with mindful reframing. This technique blends mindfulness and NLP for a balanced, resilient mindset.",
      "path": "blog/mindfulness/post/postmindfulness3"
    },
    {
      "title": "State Adjustment with Breath and Visualization",
      "date": "August 1, 2023",
      "image": "/assets/FeedItems/BB0gXqnyuFCezfRCHB7.svg",
      "summary": "Learn how to cultivate calm and confidence through mindful breathing and NLP visualization. This exercise combines relaxation techniques with powerful visualization to create a state of balance.",
      "path": "blog/mindfulness/post/postmindfulness4"
    },
    {
      "title": "Introduction to JavaScript",
      "date": "September 1, 2023",
      "image": "/assets/FeedItems/BPkKTjqufPfF8skNCRg.svg",
      "summary": "Get an overview of JavaScript, its history, and basic syntax. Learn about the fundamental concepts of JavaScript and its importance in web development.",
      "path": "blog/technology/javascript/post/postjavascript1"
    },
    {
      "title": "JavaScript Functions and Scope",
      "date": "October 1, 2023",
      "image": "/assets/FeedItems/BBW9wYFE5aKngj2p85C.svg",
      "summary": "Understand the basics of JavaScript functions and scope. Learn about defining functions, function parameters and return values, scope, and closures.",
      "path": "blog/technology/javascript/post/postjavascript2"
    },
    {
      "title": "JavaScript Arrays and Objects",
      "date": "November 1, 2023",
      "image": "/assets/FeedItems/BBxwtHYtEumaJvAF8ju.svg",
      "summary": "Explore the fundamental data structures in JavaScript: arrays and objects. Learn about working with arrays, objects, and iterating over these data structures.",
      "path": "blog/technology/javascript/post/postjavascript3"
    },
    {
      "title": "JavaScript Promises and Asynchronous Programming",
      "date": "December 1, 2023",
      "image": "/assets/FeedItems/BBETHMT5fCWQpvNDBTR.svg",
      "summary": "Learn about asynchronous programming in JavaScript using promises. Understand the basics of promises, creating and using promises, and the async/await syntax.",
      "path": "blog/technology/javascript/post/postjavascript4"
    },
    {
      "title": "Dangling pointers ",
      "date": "April 11, 2025",
      "image": "/assets/FeedItems/Cn0GfNaH99e0kUBbXYEX.svg",
      "summary": "Learn about dangling pointers in C++ when working with objects, how they occur, and how to avoid them.",
      "path": "blog/technology/cybersecurity/post/postcyber1"
    },
    {
      "title": "Triggers and Order of Execution",
      "date": "November 12, 2024",
      "image": "/assets/FeedItems/BBYqAzVX74RkVwwrt7G.svg",
      "summary": "When you save a record with an insert, update, or upsert statement, Salesforce performs a sequence of events in a certain order.",
      "path": "blog/technology/salesforce/post/postsalesforce1"
    },
    {
      "title": "Salesforce Sales Cloud: Boosting Sales Productivity",
      "date": "November 12, 2024",
      "image": "/assets/FeedItems/BBYjmWYpHxqU1NahXSK.svg",
      "summary": "Discover the features and benefits of Salesforce Sales Cloud. Learn about lead and opportunity management, sales forecasting, and reporting to boost sales productivity.",
      "path": "blog/technology/salesforce/post/postsalesforce2"
    },
    {
      "title": "Salesforce Service Cloud: Enhancing Customer Support",
      "date": "March 1, 2024",
      "image": "/assets/FeedItems/BB0DJzYds75JyH9gjyj.svg",
      "summary": "Explore the features of Salesforce Service Cloud for enhancing customer support. Learn about case management, knowledge base, and omnichannel support.",
      "path": "blog/technology/salesforce/post/postsalesforce3"
    },
    {
      "title": "Salesforce Marketing Cloud: Driving Marketing Success",
      "date": "April 1, 2024",
      "image": "/assets/FeedItems/byz2.svg",
      "summary": "Understand the features and benefits of Salesforce Marketing Cloud. Learn about email marketing, social media management, customer journey mapping, and analytics to drive marketing success.",
      "path": "blog/technology/salesforce/post/postsalesforce4"
    }
  ]
};